// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnswer, AskGetabstractQuestionAnswers } from "../schema";
import { serialize_AskGetabstractAnswer_internal, deserialize_AskGetabstractAnswer_internal } from "./AskGetabstractAnswer";

export function serialize_AskGetabstractQuestionAnswers_internal(value: AskGetabstractQuestionAnswers): unknown {
  return ((value: { current: AskGetabstractAnswer; history: AskGetabstractAnswer[] }): unknown => {
    return {
      current: ((value: AskGetabstractAnswer): unknown => {
        return serialize_AskGetabstractAnswer_internal(value);
      })(value["current"]),
      history: ((value: AskGetabstractAnswer[]): unknown => {
        return value.map((value: AskGetabstractAnswer): unknown => {
          return serialize_AskGetabstractAnswer_internal(value);
        });
      })(value["history"]),
    };
  })(value);
}
export function serialize_AskGetabstractQuestionAnswers(obj: AskGetabstractQuestionAnswers): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractQuestionAnswers_internal(obj));
}
export function deserialize_AskGetabstractQuestionAnswers_internal(value: unknown): ParserResult<AskGetabstractQuestionAnswers> {
  return ((
    value: unknown,
  ): ParserResult<{
    current: AskGetabstractAnswer;
    history: AskGetabstractAnswer[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "current")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/current]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'current'.` };
    }
    const parsed_current = ((): ParserResult<AskGetabstractAnswer> => {
      return ((value: unknown): ParserResult<AskGetabstractAnswer> => {
        return deserialize_AskGetabstractAnswer_internal(value);
      })(value["current"]);
    })();
    if (!parsed_current.success) {
      return { success: false, reason: parsed_current.reason };
    }
    if (!hasProp(value, "history")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'history'.` };
    }
    const parsed_history = ((): ParserResult<AskGetabstractAnswer[]> => {
      return ((value: unknown): ParserResult<AskGetabstractAnswer[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<AskGetabstractAnswer> => {
          return deserialize_AskGetabstractAnswer_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["history"]);
    })();
    if (!parsed_history.success) {
      return { success: false, reason: parsed_history.reason };
    }
    return { success: true, value: { current: parsed_current.value, history: parsed_history.value } };
  })(value);
}
export function deserialize_AskGetabstractQuestionAnswers(str: string): ParserResult<AskGetabstractQuestionAnswers> {
  return deserialize_AskGetabstractQuestionAnswers_internal(parseJsonWithNumbersAsBigint(str));
}
